export default {"src":"/_next/static/media/help-center.d4072dbc.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};